import * as fetchUser from "./fetchUser";
import { initialState as fetchUserInitialState, FetchUserInfoState } from "./fetchUser";
import reduceReducers from "reduce-reducers";


export const Types: { [key: string]: any } = {
    ...fetchUser.Types
};

export const Actions: { fetchUser: typeof fetchUser.Actions } = {
    fetchUser: fetchUser.Actions,
};

export const fetchUserRequestReducer = reduceReducers<FetchUserInfoState>(
    fetchUserInitialState,
    fetchUser.default as any
);

export default {
    fetchUser: fetchUserRequestReducer
};